<template>
  <v-list-item
    :key="resposta.id"
  >
    <v-list-item-content>
      <v-list-item-title>
        <v-row dense>
          <v-col cols="12" sm="4" class="text-truncate">
            <px-status-negociacao
              :status-negociacao="resposta.respostaCotacao.statusNegociacao"/>
            {{ resposta.respostaCotacao.fornecedor.pessoa.nome }}
            <px-popover-fornecedor :fornecedor-id="resposta.respostaCotacao.fornecedor.id"
                                   show-score/>
          </v-col>
          <v-col cols="12" sm="2">
            <px-forma-pagamento v-if="isRespondida"
                                :forma-pagamento="resposta.respostaCotacao.formaPagamento"
                                :prazo-pagamento="resposta.respostaCotacao.prazoPagamento"
                                :showDiv="true"/>
          </v-col>
          <v-col cols="12" sm="3">
            <div v-if="isRespondida">
              {{ resposta.valorMoedaConvertido.precoUnitario
              | currency('R$', casaDecimal) }}
              <div v-if="isMoedaEstrangeira" class="caption">
                {{
                  resposta.precoUnitario |
                    currency(simboloMoeda,
                    casaDecimal,
                    configuracaoFormatacaoMoeda)
                }}
              </div>
              <div class="caption">
                Preço unitário
              </div>
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <div v-if="isRespondida">
              {{ resposta.valorMoedaConvertido.total
              | currency('R$', casaDecimal) }}
              <px-moeda-chip :moeda="moeda" v-if="isMoedaEstrangeira"/>
              <div v-if="isMoedaEstrangeira" class="caption">
                {{
                  resposta.total |
                    currency(simboloMoeda, casaDecimal, configuracaoFormatacaoMoeda)
                }}
              </div>
              <div class="caption">
                Preço total
              </div>
            </div>
            <px-situacao-cotacao-produto :situacao="resposta.situacao"/>
          </v-col>
        </v-row>
      </v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <px-especificacao-produto-comparavel
        :especificacao="cotacaoProduto.especificacaoProduto"
        :especificacao-fornecida="resposta.especificacaoProduto"/>
    </v-list-item-action>
    <v-list-item-action v-if="isAdicionavelCarrinho">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn icon
                 v-on="on"
                 @click="adicionarItemAoCarrinho">
            <v-icon>mdi-cart</v-icon>
          </v-btn>
        </template>
        <span>Adicionar item ao carrinho</span>
      </v-tooltip>
    </v-list-item-action>
    <v-list-item-action>
      <template v-if="isModalView">
        <px-resposta-detalhes-dialog-view
          :cotacao-id="cotacaoId"
          :resposta-id="resposta.respostaCotacao.id"
          @change="onChange"
        />
      </template>
      <template v-else>
        <v-btn icon @click="onClickDetalhes">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { SituacaoRespostaCotacaoProduto, SituacaoCotacao } from 'px-business-components';
import moedaMixin from '@/mixins/moeda-mixin';
import pxRespostaDetalhesDialogView
  from '@/modules/cotacao/resposta/detalhes/RespostaDetalhesDialogView.vue';
import { isFornecedorHomologado } from '@/utils/fornecedor-produto-utils';
import { isEmpty } from 'lodash';
import { mapActions } from 'vuex';
import { ADD_ITEM } from '@/store/carrinho/actions.type';

export default {
  mixins: [moedaMixin],
  props: {
    resposta: {
      type: Object,
      required: true,
    },
    cotacaoProduto: {
      type: Object,
      required: true,
    },
    cotacaoId: {
      type: [String, Number],
      required: true,
    },
    isModalView: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    moeda() {
      return this.resposta.respostaCotacao.moeda;
    },
    isRespondida() {
      return this.resposta.situacao === SituacaoRespostaCotacaoProduto.keys.RESPONDIDA.key;
    },
    casaDecimal() {
      return this.resposta.cotacaoProduto.produto.casasDecimais;
    },
    isAberta() {
      return this.resposta.cotacaoProduto.situacao === SituacaoCotacao.keys.ABERTA.key;
    },
    isAdicionavelCarrinho() {
      return this.isAberta && this.isRespondida;
    },
  },
  methods: {
    ...mapActions('carrinho', {
      addItem: ADD_ITEM,
    }),
    isFornecedorHomologadoAoProduto(produto) {
      const { fornecedoresProduto } = produto.cotacaoProduto.produto;
      if (isEmpty(fornecedoresProduto)
        || isEmpty(fornecedoresProduto.filter(fp => fp.homologado))) {
        return true;
      }
      return isFornecedorHomologado(fornecedoresProduto,
        this.resposta.respostaCotacao.fornecedor.id);
    },
    adicionarItemAoCarrinho() {
      if (!this.isFornecedorHomologadoAoProduto(this.resposta)) {
        this.$toast(`Este fornecedor não é homologado para o produto: ${this.resposta.cotacaoProduto.produto.descricao}`, { color: 'error' });
        return;
      }
      this.addItem(this.resposta.id)
        .then(() => {
          this.$toast('Item adicionado ao carrinho', { color: 'success' });
          this.$emit('change');
        });
    },
    onClickDetalhes() {
      this.$router.push({
        name: 'main.cotacoes.respostas.detalhes',
        params: {
          id: this.cotacaoId,
          idResposta: this.resposta.respostaCotacao.id,
        },
      });
    },
    onChange() {
      this.$emit('change');
    },
  },
  components: { pxRespostaDetalhesDialogView },
};
</script>
